<template>
  <div id="stop-group">
    <stop-group-item
      v-for="(stop, index) in stopGroup"
      :key="`stop-group-item-${index}`"
      :stop="stop"
    />
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import StopGroupItem from "@/components/StopInfo/StopGroupItem";

export default {
  name: 'RouteInfoStopGroup',
  components: {StopGroupItem},
  computed: {
    ...mapState('routeInfo', ['stopGroup']),
  },
  methods: {
    ...mapActions('routeInfo', ['getStopGroup']),
  },
  mounted() {
    this.getStopGroup(this.$route.params.id);
  },
}
</script>
<style>

</style>
